import { useMemo } from 'react'

import { Collapse, CollapseProps, Empty } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { TemplateVariableType } from '@eastcoal/shared/enums/TemplateVariableType'

import { useTemplateVariableEntityGetter } from '../../hooks/useTemplateVariableEntityGetter'
import { useContractDesignerStore } from '../../Store/hooks/useStore'

import { TableVariableConfigure } from './TableVariableConfigure'
import { TemplateVariableDetail } from './TemplateVariableDetail'
import { TextVariableConfigure } from './TextVariableConfigure'

const collapseItemStyles = {
  header: {
    paddingInline: 0
  },
  body: {
    paddingInline: 0
  }
}

const COLLAPSE_ITEM_KEY_DETAIL = 'templateVariableDetail'
const COLLAPSE_ITEM_KEY_TEXT = 'textVariableConfigure'
const COLLAPSE_ITEM_KEY_TABLE = 'tableVariableConfigure'

const COLLAPSE_DEFAULT_ACTIVE_KEYS = [
  COLLAPSE_ITEM_KEY_TEXT,
  COLLAPSE_ITEM_KEY_TABLE
]

export const TemplateVariableConfigure = () => {
  const { activedVariableNodeKey } = useContractDesignerStore(state =>
    pick(state, ['activedVariableNodeKey'])
  )

  const getTemplateVariableEntity = useTemplateVariableEntityGetter()

  const templateVariableEntity = useMemo(
    () => getTemplateVariableEntity(activedVariableNodeKey),
    [activedVariableNodeKey, getTemplateVariableEntity]
  )

  const items = useMemo(() => {
    const items: CollapseProps['items'] = []
    if (!templateVariableEntity) {
      return items
    }
    items.push({
      key: COLLAPSE_ITEM_KEY_DETAIL,
      label: '基础信息',
      styles: collapseItemStyles,
      children: <TemplateVariableDetail data={templateVariableEntity} />
    })
    if (templateVariableEntity.type === TemplateVariableType.TEXT) {
      items.push({
        key: COLLAPSE_ITEM_KEY_TEXT,
        label: '参数配置',
        styles: collapseItemStyles,
        children: <TextVariableConfigure />
      })
    }
    if (templateVariableEntity.type === TemplateVariableType.TABLE) {
      items.push({
        key: COLLAPSE_ITEM_KEY_TABLE,
        label: '参数配置',
        styles: collapseItemStyles,
        children: <TableVariableConfigure data={templateVariableEntity} />
      })
    }
    return items
  }, [templateVariableEntity])

  if (!templateVariableEntity) {
    return <Empty description='请先选择模板中的参数' />
  }

  return (
    <Collapse
      ghost
      bordered={false}
      defaultActiveKey={COLLAPSE_DEFAULT_ACTIVE_KEYS}
      items={items}
    />
  )
}
